var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.36 97.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin {\n        fill: #dcba8b;\n      }\n      .cls-2 {\n        fill: #dadada;\n      }\n      .cls-3 {\n        fill: #1e0e00;\n      }\n      .cls-4 {\n        fill: #98dae5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 289.57,
    cy: 56.41,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.36,43.19a27.19,27.19,0,0,1-1.49,8.86c-4.58,13.47-19.42,24.5-39,29.56q-3.25.84-6.68,1.46A98.94,98.94,0,0,1,290,84.61h-.47c-35.78,0-64.79-18.55-64.79-41.43s29-41.43,64.79-41.43S354.36,20.31,354.36,43.19Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 64.79,
    cy: 56.41,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.58,41.43c0,22.42-27.86,40.68-62.65,41.41l-2.14,0a101.06,101.06,0,0,1-13.88-1q-4.54-.63-8.84-1.67C23.82,75.87,9.47,66.39,3.3,54.52A28.21,28.21,0,0,1,0,41.43C0,18.55,29,0,64.79,0S129.58,18.55,129.58,41.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 282.96,
    cy: 43.19,
    r: 28.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 72.28,
    cy: 41.43,
    r: 28.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.85,77.35a9.63,9.63,0,0,1-2.94,4.56C28.51,78.78,10.44,68.25,3.3,54.52c6.23-3.11,16.16-3.56,26.54-.61C45.51,58.36,56.26,68.85,53.85,77.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.87,52.05c-5.09,15-22.83,26.91-45.7,31a10.72,10.72,0,0,1-3.09-5c-2.54-9.32,9-20.59,25.79-25.16C338.33,50.61,346.52,50.45,352.87,52.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.85,81.61q-3.25.84-6.68,1.46A98.94,98.94,0,0,1,290,84.61,11.38,11.38,0,0,1,290,83.3a12,12,0,0,1,23.88-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67,81.8c0,.35,0,.7,0,1l-2.14,0a101.06,101.06,0,0,1-13.88-1q-4.54-.63-8.84-1.67A12.5,12.5,0,0,1,67,81.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset33);
export default __webpack_public_path__ + "static/media/Asset 33.7cb55bb1.svg";
export { ForwardRef as ReactComponent };